export default {
  filters: {
    managers: {
      placeholder: 'Responsables commerciaux',
    },
  },
  metrics: {
    collected_commission: 'Commission totale',
  },
  fields: {
    manager: 'Responsable',
    area: 'Localisation',
    total_amount: 'Gains',
    companies_live: 'En ligne',
    restaurant: 'Restaurant',
    live_from: 'En ligne depuis',
    plan_amount: 'Montant du forfait',
    prepayment_bonus_amount: 'Bonus de prépaiement',
    lead_source_bonus_amount: 'Bonus source de prospect',
    google_business_bonus_amount: 'Bonus connexion Google Business',
    promo_code_bonus_amount: 'Bonus code promo maître',
    smart_pricing_bonus_amount: 'Bonus tarification intelligente',
    mobile_app_bonus_amount: 'Bonus application mobile',
    sales_goal_bonus_amount: 'Bonus objectif de vente',
  },
  buttons: {
    export: 'Exporter',
  },
  toasts: {
    failed_to_load_data: 'Échec du chargement des données',
  },
};
